(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ommo-back-to-top"] && !Shopify.designMode) return;
  try {
    (function () {
    const pageTop = document.querySelector('.ommo_to_top');
    if (!pageTop) return;

    const scrollThreshold = 300;

    function updatePageTopVisibility() {
      if (window.scrollY > scrollThreshold) {
        pageTop.classList.add('is-visible');
      } else {
        pageTop.classList.remove('is-visible');
      }
    }

    pageTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    window.addEventListener('scroll', updatePageTopVisibility, { passive: true });
    updatePageTopVisibility();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-opening-redirect"] && !Shopify.designMode) return;
  try {
    (function () {
    var el = document.querySelector('.store-opening-redirect');
    if (!el) return;
    var url = el.getAttribute('data-url');
    if (!url) return;
    window.location.replace(url);
  })();
  } catch(e) { console.error(e); }
})();

})();
